import React, { useEffect, useState } from 'react';
import LoaderContainer from '../../../../components/material-ui/loader_container/LoaderContainer';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CusItemTooltip from '../../../../components/material-ui/CusItemTooltip';
import CusTooltip from '../../../../components/material-ui/CusTooltip';
import CusButton from '../../../../components/material-ui/CusButton';
import ShowContainer from '../../../../components/material-ui/ShowContainer';
import CusInput from '../../../../components/material-ui/CusInput';
import BtnTrash from '../../../../components/bonus/ui/BtnTrash';
import DeleteDialog from '../../../../components/material-ui/dialog/DeleteDialog';
import { API_CASINO } from '../../../../api/casino';
import useToast from '../../../../hooks/useToast';
import useNumberParams from '../../../../hooks/useNumberParams';
import AuthorizationSetting from './ApiSetting';
import ApiSetting from './ApiSetting';

export default function AuthorizationSettingContent() {
  const { t } = useTranslation();
  const { successToast } = useToast();
  const [createdUserInfo, setCreatedUser] = useState({});
  const [loadingUser, setLoadingUser] = useState(true);
  const [disableCreated, setDisableCreated] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const casinoId = useNumberParams('casinoId');

  useEffect(() => {
    if (!casinoId) return;
    API_CASINO.rabittMq
      .get({ casinoId })
      .then((e) => {
        const data = e.data.data;
        setCreatedUser(data);
      })
      .catch(console.error)
      .finally(() => setLoadingUser(false));
  }, [casinoId]);

  const onCreateUser = () => {
    setDisableCreated(true);
    API_CASINO.rabittMq
      .create({ casinoId })
      .then((e) => {
        setDisableCreated(false);
        const data = e.data.data;
        setCreatedUser(data);
      })
      .catch(console.error);
  };

  const onDelete = () => {
    API_CASINO.rabittMq
      .delete({ casinoId })
      .then((e) => {
        successToast('RabbitMQ user and host deleted.');
        setCreatedUser({});
      })
      .catch(console.error);
  };

  return (
    <>
      <LoaderContainer loader={loadingUser} isBox>
        <Stack gap={6}>
          <Stack gap={2.5}>
            <Stack gap={1} direction={'row'} alignItems={'center'}>
              <Box>
                <Typography component={'span'} fontWeight={600}>
                  {createdUserInfo?.userName
                    ? t('RabbitMQ User and Host')
                    : t('Create a RabbitMQ user and host.')}
                </Typography>{' '}
                <CusTooltip
                  text={
                    'The username and password are specified in the configuration file of the server from which mass mailings—created within the mailing scheduler—are sent.'
                  }
                />
              </Box>

              <ShowContainer condition={!createdUserInfo?.userName}>
                <CusButton text="Create" onClick={onCreateUser} />
              </ShowContainer>
            </Stack>

            <ShowContainer condition={createdUserInfo?.userName}>
              <Stack direction={'row'} gap={1}>
                <CusInput label={'User'} isCopyClick value={createdUserInfo?.userName} />
                <CusInput label={'Password'} isCopyClick value={createdUserInfo?.userPsword} />
                <CusInput label={'Virtual Host'} isCopyClick value={createdUserInfo?.virtHost} />
                <Box display={'flex'} alignItems={'end'}>
                  <Box display={'flex'} alignItems={'start'} gap={1}>
                    <CusItemTooltip
                      elem={<BtnTrash onDelete={() => setIsDelete(true)} />}
                      text={'Deleting a RabbitMQ user and virtual host.'}
                    />
                  </Box>
                </Box>
              </Stack>
            </ShowContainer>
          </Stack>

          <ApiSetting casinoId={casinoId} />
        </Stack>
      </LoaderContainer>

      <DeleteDialog open={isDelete} onConfirm={onDelete} onClose={() => setIsDelete(false)} />
    </>
  );
}
